import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ReportsState, reportFeatureKey } from "./reports.reducers";
import * as fromReducer from "./reports.reducers";
import { ReportConfigurationDto } from "../interfaces/report_configuration_dto";
import { ReportGeneratorDto } from "../interfaces/report_generator_dto";


const selectFeature = createFeatureSelector<ReportsState>(reportFeatureKey);


const selectReportGeneratorsState = createSelector(
  selectFeature,
  (state: ReportsState) => state.reportGenerators
);

const selectReportConfigurationsState = createSelector(
  selectFeature,
  (state: ReportsState) => state.reportConfigurations
);

export const {
  selectAll: selectAllReports,
  selectEntities: selectReportEntities,
} = fromReducer.reportGeneratorAdapter.getSelectors(selectReportGeneratorsState);

export const {
  selectAll: selectAllReportConfigurations,
  selectEntities: selectReportConfigurationEntities,
} = fromReducer.reportConfigurationAdapter.getSelectors(selectReportConfigurationsState);

export const selectReportsInStorage = createSelector(
  selectAllReports,
  (reports: ReportGeneratorDto[]) => reports.filter((report) => report.storage_save)
);

export const selectReportById = (id: number) =>
  createSelector(selectReportEntities, (entities) => entities[id]);

export const selectReportConfigurationsByScreen = (screen: string) =>
  createSelector(selectAllReportConfigurations, (configurations: ReportConfigurationDto[]) => 
    configurations.filter((config) => config[screen as keyof ReportConfigurationDto] !== null)
  );

export const selectIsLoaded = createSelector(
  selectFeature,
  (state: ReportsState) => state.isLoaded
);
